import './HexInput.css'
import { Form } from 'react-bootstrap'

const HexInput = ({ value, onChange }) => {

	const handleChange = (e) => {
		const input = e.target
		const pos = input.selectionStart

		input.value = input.value.toLowerCase()
		input.value = input.value.replace(/[^0123456789abcdef]/, "")

		input.setSelectionRange(pos, pos)

		const v = input.value
		input.value = '0x' + (input.value)
		input.number = parseInt(input.value, 16) || ""
		onChange(e)
		input.value = v
	}

	if (value === undefined) {
		value = ""
	} else if (typeof value === 'string') {
		if (value !== "") {
			value = parseInt(value, 16)

			if (isNaN(value)) {
				value = 0
			}
		}
	} else {
		value = value.toString(16)
	}


	return (
		<>
		<span className="pre-hex-label">0x</span>
		<Form.Control
			className="hex-input"
			type="text"
			onChange={handleChange}
			value={value}
			placeholder="0"
		/>
		</>
	)
}

export default HexInput
